import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calioTranslateResolver',
  standalone: true
})
export class CalioTranslateResolverPipe implements PipeTransform {
  transform(value: string, params?: { [key: string]: any }): string {
    if (!value) return '';
    if (params) {
      Object.keys(params).forEach(key => {
        const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
        value = value.replace(regex, params[key]);
      });
    }
    return value;
  }
}